import { redirectIOA } from 'common/compositions/RedirectIOA';
import CommonAuthnApiNew from 'common/http/services/AuthnApi';
import JSRuntime from 'common/utils/JSRuntime';
import { ENTERPRISE_LOGIN_TYPE, IAuthenticatedAccount } from 'idpBase/Constants';
import { Oauth2Api as CommonAccountApi } from 'idpBase/http';
import { TGlobalStore, TUpdateStore } from 'idpBase/store';

class SelectAccountStore {
  public readonly global: TGlobalStore;
  public updateStore: TUpdateStore<SelectAccountStore>;
  public resetStore: () => void;

  public isAccountLoading = true;
  public isAmrSSO = false;
  public selectedAccountId = '';
  public accounts: IAuthenticatedAccount[] = [];

  public init() {
    this.updateStore({
      selectedAccountId: this.global.rootStore.account?.accountId,
    });
    return Promise.all([this.getAccounts(), this.global.rootStore.getAppsInfo()]);
  }

  private async getAccounts() {
    const searchParams = JSRuntime.parseLocationSearch();
    const amr = m.get(searchParams, 'amr');
    if (amr === ENTERPRISE_LOGIN_TYPE) {
      const {
        account,
        userInfo: { accountUser },
      } = this.global.rootStore || {};
      // 补充accounts的数据结构，统一展示样式与后续数据获取
      this.updateStore({
        accounts:
          account && accountUser
            ? [
                {
                  id: account.accountId,
                  in_handshake: true,
                  inviter_name: '',
                  logo_url: accountUser.avatarUrl,
                  name: account.name,
                  type: account.accountType,
                  user_name: accountUser.name,
                  union_id: '',
                },
              ]
            : [],
        isAccountLoading: false, // 非企业加载状态...
        isAmrSSO: true,
      });
      return;
    }

    const res = await CommonAccountApi.getAuthenticatedAccounts({ app: JSRuntime.appFromUrl });
    if (!res.errCode) {
      this.updateStore({
        accounts: res.accounts,
      });
    }
    this.updateStore({
      isAccountLoading: false,
    });
  }

  public async changeAccount(params: {
    id?: string;
    isEmail?: boolean;
    unionId?: string;
    skipSelect?: string;
  }) {
    const res = await (params.isEmail
      ? CommonAuthnApiNew.changeEmailAccount(
          params?.id || this.selectedAccountId,
          params?.unionId || '',
        )
      : CommonAuthnApiNew.changeAccount(
          params?.id || this.selectedAccountId,
          params?.unionId || '',
          JSRuntime.appFromUrl,
        ));
    if (!redirectIOA(res, JSRuntime.getPortalSite())) {
      this.global.rootStore.redirectToLandingPage({ skipSelect: params.skipSelect });
    }
  }
}

export default SelectAccountStore;
